export default {
  displayFormat(value) {
    if (value || value === 0) {
      const patt = /(^(((0?\d|1[01]):[0-5]\d)|12:00)$)/; //od 00:00 do 12:00
      const testRes = patt.test(value.toString());
      let toReturnVal = '';
      if (testRes) {
        toReturnVal = value;
      } else {
        toReturnVal = '0:00';
      }
      return toReturnVal;
    }
    return '0:00';
  },
  modelFormat(valueToFormat) {
    return valueToFormat.replace(/ /g, ''); //.replace('.',',')
  },
};
